import { BASE_URL } from 'config';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import walletOperationsTableData from "./data/walletOperationsTableData";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ContentCopy from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";

function WalletOperations() {
  const { walletId } = useParams();
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchName, setSearchName] = useState("");
  const [walletCode, setWalletCode] = useState("");
  const [showCode, setShowCode] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    const fetchWallet = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("user-token");
        const response = await fetch(
          `${BASE_URL}/administrator/wallets/show/${walletId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setWallet(data.data);
        if (
          data.data &&
          (data.data.user?.type === "مشرف" || data.data.user?.type === "administrator")
        ) {
          console.log("admin wallet", data.data);
          const codeRes = await fetch(
            BASE_URL + "/administrator/wallets/get-code",
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const codeText = await codeRes.text();
          setWalletCode(codeText || "");
        }
      } catch (error) {
        setWallet(null);
      }
      setLoading(false);
    };
    fetchWallet();
  }, [walletId]);

  let tableData = wallet ? walletOperationsTableData(wallet) : { columns: [], rows: [] };

  if (searchName && tableData.rows.length > 0) {
    tableData = {
      ...tableData,
      rows: tableData.rows.filter(
        (row) =>
          row.fromTo && row.fromTo.toString().toLowerCase().includes(searchName.toLowerCase())
      ),
    };
  }

  const totals = { شحن: 0, سحب: 0, "تحويل صادر": 0, "تحويل وارد": 0 };
  tableData.rows.forEach((row) => {
    if (totals[row.type] !== undefined) {
      totals[row.type] += parseFloat(row.amount || 0);
    }
  });

  return (
    <MDBox mt={4} display="flex" flexDirection="column" alignItems="center">
        {/* حركة التحميل */}
        {loading && (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="300px">
            <CircularProgress color="info" size={60} thickness={4.5} />
          </MDBox>
        )}
        {/* بطاقة بيانات المحفظة */}
        {!loading && wallet && (
          <>
            <div
              style={{
                minWidth: 350,
                maxWidth: 420,
                marginBottom: 32,
                padding: 24,
                borderRadius: 16,
                boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.25)",
                textAlign: "center",
                position: "relative",
                background: "linear-gradient(135deg, #6a5af9 0%, #7b2ff2 60%, #38f9d7 100%)",
                color: "#fff",
                border: "2px solid #fff3",
                overflow: "hidden",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
            >
              <WalletIcon
                sx={{ fontSize: 54, color: "#fff", mb: 1, filter: "drop-shadow(0 2px 8px #0002)" }}
              />
              <MDTypography variant="h5" fontWeight="bold" mb={1} sx={{ color: "#fff" }}>
                {wallet.user?.name || "-"}
              </MDTypography>
              <MDTypography variant="body2" sx={{ color: "#e0e0e0", mb: 1 }}>
                رقم المحفظة: {wallet.id}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="bold" mb={1} sx={{ color: "#fff" }}>
                الرصيد: {wallet.balance} {wallet.currency?.name}
              </MDTypography>
              <MDTypography variant="body2" sx={{ color: "#fff", opacity: 0.9, mb: 1 }}>
                النوع: {wallet.user?.type || "-"}
              </MDTypography>
              {/* كود محفظة الأدمن */}
              {(wallet.user?.type === "مشرف" || wallet.user?.type === "administrator") &&
                walletCode && (
                  <MDBox display="flex" alignItems="center" justifyContent="center" mb={1} gap={1}>
                    <MDTypography variant="body2" sx={{ color: "#fff", opacity: 0.9 }}>
                      الكود :
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      sx={{
                        color: "#fff",
                        background: "#2228",
                        borderRadius: 1,
                        px: 1.5,
                        letterSpacing: 2,
                        fontFamily: "monospace",
                        fontSize: 18,
                        userSelect: showCode ? "text" : "none",
                      }}
                    >
                      {showCode ? walletCode : "*".repeat(walletCode.length)}
                    </MDTypography>
                    <IconButton
                      size="small"
                      sx={{ color: "#fff" }}
                      onClick={() => setShowCode((v) => !v)}
                      title={showCode ? "إخفاء الكود" : "إظهار الكود"}
                    >
                      {showCode ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                    <IconButton
                      size="small"
                      sx={{ color: copySuccess ? "#bbf7d0" : "#fff" }}
                      onClick={async () => {
                        try {
                          await navigator.clipboard.writeText(walletCode);
                          setCopySuccess(true);
                          setTimeout(() => setCopySuccess(false), 1200);
                        } catch {}
                      }}
                      title="نسخ الكود"
                    >
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </MDBox>
                )}
              <MDTypography
                variant="body2"
                sx={{ color: wallet.status === "active" ? "#bbf7d0" : "#fecaca", fontWeight: 700 }}
              >
                {wallet.status === "active" ? "نشطة" : "غير نشطة"}
              </MDTypography>
            </div>
            {/* إجمالي كل نوع عملية */}
            <MDBox display="flex" justifyContent="center" gap={2} mb={3} flexWrap="wrap">
              {Object.entries(totals).map(([type, total]) => (
                <MDBox
                  key={type}
                  sx={{
                    minWidth: 120,
                    background: "#fff",
                    color: "#222",
                    borderRadius: 3,
                    boxShadow: "0 2px 12px #0001",
                    p: 2,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  <div style={{ fontSize: 15, marginBottom: 4 }}>{type}</div>
                  <div style={{ fontSize: 18, color: "#6a5af9" }}>{total.toFixed(2)}</div>
                </MDBox>
              ))}
            </MDBox>
          </>
        )}
        {/* حقل البحث وجدول العمليات */}
        {!loading && wallet && (
          <Card sx={{ width: "100%", maxWidth: 1200, p: 2, borderRadius: "16px", boxShadow: 2 }}>
            <MDTypography variant="h6" fontWeight="bold" mb={2} textAlign="center">
              عمليات المحفظة
            </MDTypography>
            <TextField
              fullWidth
              label="بحث باسم من/إلى"
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
            <DataTable
              table={tableData}
              isSorted={false}
              entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
              showTotalEntries={true}
              canSearch={false}
              noEndBorder
            />
          </Card>
        )}
      </MDBox>
    
  );
}

export default WalletOperations;
